export default __webpack_public_path__ + "static/media/l2.357e5509.jpg";